














// vendor
import { defineComponent, computed, ref } from "@vue/composition-api";

export default defineComponent({

	emits:[],
	props:{
		variant:{
			type:String,
		},
		text:{
			type:String,
			default:"",
		},
	},
	setup(){
		return {};
	}
});

